import { Clinic } from '../models/clinic';
import { CityId } from '../models/city';

// TODO Add Synlab
const CLINIC_LIST_BASE: ReadonlyArray<Omit<Clinic, 'id'>> = [
  {
    city: CityId.Nicosia,
    coords: [35.165719, 33.363361],
    email: 'ccharila@spidernet.com.cy',
    phones: ['22758858', '99657171'],
    title: 'Biomedical Laboratories Charis Ch. Charilaou',
  },
  {
    city: CityId.Nicosia,
    coords: [35.163046, 33.363498],
    email: 'info@adamoulab.com',
    phones: ['22762999'],
    title: 'A.Adamou Clinical Lab',
  },
  {
    city: CityId.Nicosia,
    coords: [35.16233, 33.367433],
    email: 'charism@cytanet.com.cy',
    phones: ['22759901'],
    title: 'MEDIFOS - Laboratory Medicine and Molecular Diagnosis centre',
  },
  {
    city: CityId.Nicosia,
    coords: [35.164339, 33.318428],
    email: 'charism@cytanet.com.cy',
    phones: ['22760943'],
    title: 'MEDIFOS - Laboratory Medicine and Molecular Diagnosis centre',
  },
  {
    city: CityId.Nicosia,
    coords: [35.148515, 33.384225],
    email: 'charism@cytanet.com.cy',
    phones: ['22759906'],
    title: 'MEDIFOS - Laboratory Medicine and Molecular Diagnosis centre',
  },
  {
    city: CityId.Nicosia,
    coords: [35.121776, 33.319059],
    email: 'charism@cytanet.com.cy',
    phones: ['22759902'],
    title: 'MEDIFOS - Laboratory Medicine and Molecular Diagnosis centre',
  },
  {
    city: CityId.Nicosia,
    coords: [35.109907, 33.383487],
    email: 'charism@cytanet.com.cy',
    phones: ['22759903'],
    title: 'MEDIFOS - Laboratory Medicine and Molecular Diagnosis centre',
  },
  {
    city: CityId.Nicosia,
    coords: [35.164907, 33.364405],
    email: 'theo.pathlab@cytanet.com.cy',
    phones: ['22750616', '22755712'],
    title: 'Theocharides clinical labs',
    website: 'theocharideslab.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.158678, 33.367684],
    email: 'theo.pathlab@cytanet.com.cy',
    phones: ['22376534'],
    title: 'Theocharides clinical labs',
    website: 'theocharideslab.com',
  },
  {
    city: CityId.Limassol,
    coords: [34.70911, 33.0548],
    email: 'mygene.cy@gmail.com',
    phones: ['99539853'],
    title: 'MyGene Molecular Diagnostics',
    website: 'mygene-cy.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.153864, 33.33916],
    email: 'cdlab@cytanet.com',
    phones: ['22451246', '99678714'],
    title: 'Diogenous lab (C.D. DNA Biomedica Science Lab)',
    website: 'diogenouslab.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.1538, 33.36661],
    email: 'info@yiannouka.com.cy',
    phones: ['77771310', '22204900'],
    title: 'Bioiatriki  Group (Yannioukas labs)',
    website: 'labcy.com',
  },
  {
    city: CityId.Limassol,
    coords: [34.698336, 33.043345],
    email: 'info@bio-analysis.com',
    phones: ['25726252', '25721992'],
    price: 75,
    title: 'Bioanalysis Clinical Labs',
    website: 'bio-analysis.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.1663983, 33.3648708],
    email: 'info@bhsdiagnostics.com',
    phones: ['22762213'],
    title: 'Tymvios Clinical Labs',
    website: 'tymvioslabs.com',
  },
  {
    city: CityId.Limassol,
    coords: [34.685651, 33.034816],
    email: 'lab@pzalab.com.cy',
    phones: ['25381373', '25442443'],
    title: 'PZ Agapiou Diagnostics',
    website: 'pzalab.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.121702, 33.341462],
    email: 'info@amc.com.cy',
    phones: ['25381373', '25442443'],
    title: 'American Medical Center',
    website: 'amc.com.cy',
  },
  {
    city: CityId.Limassol,
    coords: [34.677597, 33.03865],
    email: 'info@amc.com.cy',
    phones: ['25859359'],
    title: 'American Medical Center',
    website: 'amc.com.cy',
  },
  {
    city: CityId.Paphos,
    coords: [34.762815, 32.438381],
    email: 'lab@iasishospital.com',
    phones: ['26848484'],
    title: 'Iasis',
    website: 'iasishospital.com',
  },
  {
    city: CityId.Paphos,
    coords: [34.786584, 32.437957],
    email: 'info@evangelismos.com.cy',
    phones: ['26848111', '26848000'],
    title: 'Evangelismos',
    website: 'evangelismos.com.cy',
  },
  // {
  //   city: CityId.Paphos,
  //   coords: [34.882414, 32.380522],
  //   email: "info@evangelismos.com.cy",
  //   phones: ["26848111", "26910888"],
  //   title: "Evangelismos",
  //   website: "evangelismos.com.cy",
  // },
  // {
  //   city: CityId.Paphos,
  //   coords: [35.033816, 32.427334],
  //   email: "info@evangelismos.com.cy",
  //   phones: ["26848111", "26323434"],
  //   title: "Evangelismos",
  //   website: "evangelismos.com.cy",
  // },
  {
    city: CityId.Limassol,
    coords: [34.681965, 33.040425],
    email: 'lab@ygiapolyclinic.com',
    phones: ['77777790', '25884636', '25884643'],
    price: 75,
    title: 'Ygia polyclinic',
    website: 'ygiapolyclinic.com',
  },
  {
    city: CityId.Limassol,
    coords: [34.705093, 33.028256],
    phones: ['25200000'],
    title: 'Mediterranean hospital of cyprus',
    website: 'medihospital.com.cy',
  },
  {
    city: CityId.Larnaca,
    coords: [34.923853, 33.616364],
    phones: ['24818183', '24818184'],
    title: 'A.Evangelou Lab ',
    email: 'info@biodiagnostiki.com',
    website: 'biodiagnostiki.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.139291, 33.364024],
    phones: ['22200300'],
    title: 'Aretaieio Hospital',
    email: 'info@aretaeio.com',
    website: 'aretaeio.com',
  },
  {
    city: CityId.Nicosia,
    coords: [35.165857, 33.325009],
    email: 'info@nipd.com',
    phones: ['22266888'],
    price: 65,
    title: 'NIPD genetics',
    website: 'nipd.com',
  },
  {
    city: CityId.Limassol,
    coords: [34.714581, 32.99873],
    phones: ['22266888'],
    price: 65,
    title: 'NIPD genetics (Spyros Kyprianou Athletic Center-Palais de Sports)',
    email: 'info@nipd.com',
    website: 'nipd.com',
  },
  {
    city: CityId.Larnaca,
    coords: [34.926056, 33.600608],
    phones: ['22266888'],
    price: 65,
    title: 'NIPD genetics (New GSZ Stadium parking)',
    email: 'info@nipd.com',
    website: 'nipd.com',
  },
  {
    city: CityId.Famagusta,
    coords: [35.030712, 33.988118],
    phones: ['22266888'],
    price: 65,
    title: 'NIPD genetics ("Tasos Markou" Paralimni Stadium parking)',
    email: 'info@nipd.com',
    website: 'nipd.com',
  },
];

export const CLINIC_LIST = CLINIC_LIST_BASE.map((clinic, index) => ({
  ...clinic,
  id: index,
}));
